import { render } from "./banner.vue?vue&type=template&id=16952df6"
import script from "./banner.vue?vue&type=script&lang=js"
export * from "./banner.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__